import { timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgxComponentsConfig } from '@app/ngx-components/ngx-components.config';

const quotes = [
  'This is the way.',
  'May the Force be with you.',
  "I'm gonna make him an offer he can't refuse.",
  'The Dude abides.',
  'Just keep swimming.',
  "Mama says, 'Stupid is as stupid does.'",
  "Here's Johnny!",
  "You can't handle the truth!",
  "I'll be back.",
  'Why so serious?',
  'Winter is coming.',
  'A Lannister always pays his debts.',
  'A lion doesn’t concern himself with the opinions of a sheep.',
  'All men must die, but we are not men.',
  'If you think this has a happy ending you haven’t been paying attention.',
];

const checkHeartBeat = (heartbeat: string, http: HttpClient, enableQuotes = false) => {
  const interval = 2 * 60 * 1000;
  const heartBeat$ = timer(0, interval).pipe(switchMap(() => http.get(heartbeat)));
  heartBeat$.subscribe(() => {
    if (enableQuotes) {
      const message = quotes[0];
      console.info(message);
    }
  });
};

/**
 * HeartBeat can initialized by implementing HeartBeatService
 * and creating InjectionToken for the implementation. This injection token should be used to
 * provide the service and also set in the heartbeat configuration.
 *
 * ```
 * const HEART_BEAT_TOKEN = new InjectionToken<HeartBeatService>('CONFIG_SERVICE');
 * const config: NgxComponentsConfig = {
 *   moduleName: 'Demo APP',
 *   heartbeat: { injectionToken: HEART_BEAT_TOKEN },
 *   logger: {
 *     type: LoggerType.CONSOLE
 * }
 *
 * @NgModule({
 * declarations: [
 *   AppComponent
 * ],
 * imports: [
 *   BrowserModule,
 *   CommonModule,
 *   NgxComponentsModule.forRoot(config)
 * ],
 * providers: [
 *   {
 *     provide: HEART_BEAT_TOKEN,
 *     useClass: ConfigService
 *   }
 * ],
 * schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
 * bootstrap: [ AppComponent ]
 * })
 * export class AppModule { }
 * ```
 *
 * @param config
 * @param injector
 * @param http
 */
export const heartBeatFactory = (
  config: NgxComponentsConfig,
  injector: Injector,
  http: HttpClient,
) => {
  let heartbeatURL: any;
  if (config.heartbeat) {
    const service = injector.get(config.heartbeat.injectionToken);
    heartbeatURL = service.getHeartBeatURL();
  }
  if (heartbeatURL && typeof heartbeatURL.then === 'function') {
    heartbeatURL.then((url: string) => {
      checkHeartBeat(url, http, config.heartbeat.crazy);
    });
  } else if (heartbeatURL && typeof heartbeatURL === 'string') {
    checkHeartBeat(heartbeatURL, http, config.heartbeat && config.heartbeat.crazy);
  }

  return () => true;
};
